import api from './api';
import auth from '../../login/saga';

const sagas = [api, auth];
export default sagas;
